import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getCountryListAPI,
  getStateListAPI,
  getCityListAPI,
} from "./cityStateCountryAPI";

export const getCountryList = createAsyncThunk(
  "country/getCountryList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getCountryListAPI();
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch countries");
    }
  }
);

export const getStateList = createAsyncThunk(
  "country/getStateList",
  async (countryId, { rejectWithValue }) => {
    try {
      const response = await getStateListAPI(countryId);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch states");
    }
  }
);

export const getCityList = createAsyncThunk(
  "country/getCityList",
  async (stateId, { rejectWithValue }) => {
    try {
      const response = await getCityListAPI(stateId);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch cities");
    }
  }
);

const initialState = {
  getCountryList: { data: [], loading: false, error: null },
  getStateList: { data: [], loading: false, error: null },
  getCityList: { data: [], loading: false, error: null },
};

const countrySlice = createSlice({
  name: "country",
  initialState,
  reducers: {
    clearCountries: (state) => {
      state.getCountryList.data = [];
      state.getCountryList.error = null;
    },
    clearStates: (state) => {
      state.getStateList.data = [];
      state.getStateList.error = null;
    },
    clearCities: (state) => {
      state.getCityList.data = [];
      state.getCityList.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCountryList.pending, (state) => {
        state.getCountryList.loading = true;
        state.getCountryList.error = null;
      })
      .addCase(getCountryList.fulfilled, (state, action) => {
        state.getCountryList.loading = false;
        state.getCountryList.data = action.payload?.data || [];
      })
      .addCase(getCountryList.rejected, (state, action) => {
        state.getCountryList.loading = false;
        state.getCountryList.error = action.payload;
      });

    builder
      .addCase(getStateList.pending, (state) => {
        state.getStateList.loading = true;
        state.getStateList.error = null;
      })
      .addCase(getStateList.fulfilled, (state, action) => {
        state.getStateList.loading = false;
        state.getStateList.data = action.payload?.data || [];
      })
      .addCase(getStateList.rejected, (state, action) => {
        state.getStateList.loading = false;
        state.getStateList.error = action.payload;
      });

    builder
      .addCase(getCityList.pending, (state) => {
        state.getCityList.loading = true;
        state.getCityList.error = null;
      })
      .addCase(getCityList.fulfilled, (state, action) => {
        state.getCityList.loading = false;
        state.getCityList.data = action.payload?.data || [];
      })
      .addCase(getCityList.rejected, (state, action) => {
        state.getCityList.loading = false;
        state.getCityList.error = action.payload;
      });
  },
});

export const { clearCountries, clearStates, clearCities } = countrySlice.actions;
export default countrySlice.reducer;